export const BASE_URL = 'https://dummyjson.com';

export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCT_BY_ID: '/products/',
  SEARCH: '/products/search',
  CATEGORY: '/products/category-list',
  PRODUCTS_BY_CATEGORY: '/products/category/',
};

export const ITEMS_PER_PAGE = 12;